module.exports = __webpack_public_path__ + "static/media/soia.be35693a.svg";